import { render, staticRenderFns } from "./UpperRightNavigation.vue?vue&type=template&id=4da44456&scoped=true&"
import script from "./UpperRightNavigation.vue?vue&type=script&lang=js&"
export * from "./UpperRightNavigation.vue?vue&type=script&lang=js&"
import style0 from "./UpperRightNavigation.vue?vue&type=style&index=0&id=4da44456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da44456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
